import '@vanilla-extract/css/vanilla.virtual.css?ve-css=Lnh6a3NpaTAgewogIGRpc3BsYXk6IGJsb2NrOwp9';
export var labelClass = 'xzksii0';